export default "__VITE_ASSET__4rTpgqSd__"